import { useEffect } from "react";

import LocalStorage from "services/LocalStorage";
import useBoundStore from "store";

function LocalStorageInitializer() {
  const setGeneralSettings = useBoundStore((state) => state.generalSettings.set);
  const setAppData = useBoundStore((state) => state.appData.set);
  const localStorage = LocalStorage.getInstance();

  useEffect(() => {
    const externalLinkNavigation = localStorage.getConfirmExternalLinkNavigation();
    const googleCalendar = localStorage.getGoogleCalendarEvent();
    const mode = localStorage.getPaletteMode();
    const primaryColor = localStorage.getPrimaryColor();
    const appData = localStorage.getAppData();

    setGeneralSettings({
      externalLinkNavigation,
      googleCalendar,
      primaryColor,
      theme: mode,
    });

    if (appData) {
      appData.initialized = false;
      setAppData({
        ...appData,
        storedInLocalStorage: true,
      });
    }
  }, [setAppData, localStorage]);

  return null;
}

export default LocalStorageInitializer;
